module.exports = __webpack_public_path__ + "static/request-illus-93438f23b05de8c529660f3251c7b68f.svg";